import React from 'react'
import styled from 'styled-components'
import BlogInstance from '../../components/blog/BlogInstance'
import { device } from '../../styles/styles'
import { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Layout from '../../components/general/Layout'

const BlogsContainer = styled.main`
display: grid;
grid-template-columns: 1fr;
grid-gap: 1rem;
padding: 1rem;
min-height: 100%;


@media ${device.laptopSmall}{
  grid-template-columns: repeat(3, 1fr);


}
`
const Page = (props) => {
 
  return (
  
    <BlogsContainer className='sectionPadding'>
      {props.blogs.map((blog) => {
        return <BlogInstance {...blog} key={blog._id} id={blog._id} />
      })}
        
    </BlogsContainer>
  )
}

export default Page


export const getStaticProps:GetServerSideProps = async (context) => {
  // Fetch data from external API
  const res = await fetch("https://www.beelocals.com/api/blog", {
    method: "GET",
        headers:{
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
  })
  // context.res.setHeader(
  //   'Cache-Control',
  //   'public, s-maxage=10, stale-while-revalidate=59'
  // )
  
  const data = await res.json()
  const blogs = data.data.filter(blog=>blog.active===true)
  // Pass data to the page via props and locale props
  return { props: { 
    blogs,
    ...(await serverSideTranslations(context.locale ?? 'en', ["common"])),
  } }
  
}





Page.getLayout = function getLayout(page) {
  return (
      <Layout>{page}</Layout>
  )
}